import { Title } from "components/common/StandardText";
import { FormattedMessage } from "react-intl";

const ReviewThankYou = () => {
  return (
    <Title level={2} style={{ width: "100%", textAlign: "center" }}>
      <FormattedMessage
        id="standalone.reviews.feedbackFormThankYouMessage"
        defaultMessage="Thank you for your review!"
        description="Reviews: Wiadomość po dobrej ocenie"
      />
    </Title>
  );
};

export default ReviewThankYou;